import {GET} from "../../constants/HTTPConstants";
import API from "./APIServices";

export const _getProfile = () => {
    return API.makeAuthRequest({
        method: GET,
        url: '/v2/user/profile'
    }, true);
};



// WEBPACK FOOTER //
// ./src/services/apis/UserServices.js